import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { breakpoints } from '@styles/index';
import Button from '@base/Button/Button';
import useOneLinkSmartScript from '@hooks/useOneLinkSmartScript';
import { SYLLABUS_PAGE } from '@constants/appFlyerLinks';
import { CONTINUE_ON_APP } from '@constants/segment';
import useAppInstallAnalytics from '@hooks/useAppInstallAnalytics';

const SmallHeaderWrapper = styled.div`
  display: none;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    top: unset !important;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px;
    display: ${({ $scroll }) => ($scroll ? 'block' : 'none')};
    position: fixed;
    z-index: 1;
    background: var(--color-i-white);
    padding-top: 0px;
  }
`;

const FeedButton = styled(Button)`
  grid-row: span 2;
  @media only screen and (max-width: 47.95em) {
    margin-top: 16px;
    width: 100%;
  }
`;

const SubHeader = () => {
  const [scroll, setScroll] = useState(false);
  const sendAapInstallAnalytics = useAppInstallAnalytics();
  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = document.documentElement;
      if (scrollTop > 280 && !scroll) {
        setScroll(true);
      } else if (scrollTop < 280 && scroll) {
        setScroll(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scroll]);

  const appDownloadLink = useOneLinkSmartScript(SYLLABUS_PAGE);

  const handleOnClick = () => {
    sendAapInstallAnalytics({
      button_text: CONTINUE_ON_APP
    });
  };

  return (
    <SmallHeaderWrapper $scroll={scroll}>
      <a href={appDownloadLink} target="_blank" rel="noopener noreferrer">
        <FeedButton label="Continue on App" onClick={handleOnClick} />
      </a>
    </SmallHeaderWrapper>
  );
};
export default SubHeader;
